import { z } from "zod";

export const simpleFilterOperatorSchema = z.enum(["equals", "notEquals"]);

export type SimpleFilterOperator = z.infer<typeof simpleFilterOperatorSchema>;

export const SIMPLE_FILTER_OPERATOR_VALUES = ["equals", "notEquals"] as const;

export const SIMPLE_FILTER_OPERATOR_LABELS: Record<
  SimpleFilterOperator,
  string
> = {
  equals: "es",
  notEquals: "no es",
};

export function parseSimpleFilterOperator(
  value: string | string[] | undefined
): SimpleFilterOperator | undefined {
  return typeof value === "string"
    ? simpleFilterOperatorSchema.safeParse(value).data
    : undefined;
}

export function normalizeSimpleFilterOperator(
  value: SimpleFilterOperator | undefined
): SimpleFilterOperator {
  return value ?? "equals";
}

/** A date filter bounded on one side: "desde" or "hasta" a date. */
export type DateAnchorFilterOperator = "since" | "until";

export type HistoricalDateFilterOperator =
  | DateAnchorFilterOperator
  | SimpleFilterOperator;

export const HISTORICAL_DATE_FILTER_OPERATOR_LABELS: Record<
  HistoricalDateFilterOperator,
  string
> = {
  ...SIMPLE_FILTER_OPERATOR_LABELS,
  since: "desde",
  until: "hasta",
};

export function isDateAnchorFilterOperator(
  operator: string
): operator is DateAnchorFilterOperator {
  return operator === "since" || operator === "until";
}
